import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import { Form } from 'react-bootstrap'

/**
 * @param {{
 *    id: string
 *    name: string
 *    defaultValue?: any
 *    className?: string
 *    disabled?: boolean
 *    onChange?: any
 *    value?: any
 *    maxLength?: number
 *    minLength?: number
 * }} props
 * @returns {React.Component}
 */
const ZariInputText = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <Form.Control
      {...props}
      ref={ref}
      className={clsx('zr-form__control zr-form__input-text', className)}
      type='text'
      size='sm'
      autoComplete='off'
    />
  )
})

ZariInputText.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.any,
  value: PropTypes.any,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  maxLength: PropTypes.number,
  minLength: PropTypes.number
}

ZariInputText.displayName = 'ZariInputText'

export default ZariInputText
